import { AfterViewInit, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { LegalLayoutComponent } from '../legal-layout.component';
import { UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  standalone: true,
  imports: [LegalLayoutComponent, UpperCasePipe, TranslateModule],
})
export class TermsComponent implements AfterViewInit {
  private eventManager = inject(EventManager);
  private dialog = inject(MatDialog);

  protected readonly NonPersistedModalName = NonPersistedModalName;

  ngAfterViewInit(): void {
    const openPrivacyElements = document.querySelectorAll('.openPrivacy');
    const openCookiesElements = document.querySelectorAll('.openCookies');

    openPrivacyElements.forEach((el) =>
      el.addEventListener('click', () => {
        this.openPrivacy();
      })
    );

    openCookiesElements.forEach((el) =>
      el.addEventListener('click', () => {
        this.openCookies();
      })
    );
  }

  openPrivacy(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.TermsComponent, ModalType.View));

    this.dialog
      .getDialogById(NonPersistedModalName.TermsComponent)
      .afterClosed()
      .subscribe(() => {
        this.eventManager.openModal(new Modal(NonPersistedModalName.PrivacyComponent, ModalType.View));
      });
  }

  openCookies(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.TermsComponent, ModalType.View));

    this.dialog
      .getDialogById(NonPersistedModalName.TermsComponent)
      .afterClosed()
      .subscribe(() => {
        this.eventManager.openModal(new Modal(NonPersistedModalName.CookiesComponent, ModalType.View));
      });
  }
}
